import styled, { css } from 'styled-components';

import { Text, utils } from '@desygner/ui-common-components';

import { CardType } from './CardFooter.props';

const CardFootContainer = styled.div<{ cardType: CardType }>`
  display: flex;
  flex-direction: row;
  padding-top: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`};
  padding-bottom: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`};
  overflow: hidden;
  gap: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`};

  .ant-checkbox-wrapper {
    //TODO FLUER-3 don't set height for Project
    height: ${({ theme }) => `${utils.rem(theme.Spacing.Size.MediumLarge)}`}!important;
    align-items: center;
  }

  .ant-checkbox {
    display: inline-flex;
    align-items: center !important;
    align-content: center !important;
    justify-content: center !important;
    margin-right: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`}!important;
    height: ${({ theme }) => `${utils.rem(theme.Spacing.Size.Medium)}`}!important;
  }

  .ant-avatar {
    height: ${({ theme }) => `${utils.rem(theme.Spacing.Size.MediumLarge)}`}!important;
    width: ${({ theme }) => `${utils.rem(theme.Spacing.Size.MediumLarge)}`}!important;
  }

  ${({ cardType }) => {
    //Add styles for project
    if (['project', 'asset'].includes(cardType)) {
      return css`
        padding-top: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XSmall)}`};
      `;
    }

    return css``;
  }};
`;

const LeftColumn = styled.div<{
  componentType: 'avatar' | 'checkbox' | 'icon';
}>`
  align-self: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${({ componentType }) => {
    if (componentType !== 'checkbox') {
      return css`
        min-width: fit-content;
      `;
    }

    return css``;
  }};
`;

const CenterColumn = styled.div`
  align-self: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const RightColumn = styled.div`
  display: inline-flex;
  flex: 1;
  align-items: center;
  flex-direction: row-reverse;
  text-align: right;
  gap: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XXSmall)}`};
  min-width: fit-content;
`;

const TemplateName = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  color: ${({ theme }) => theme.Color.Neutrals.Dark};
  font-family: ${({ theme }) => theme.Typography.Size.SmallHeavy.FontFamily};
  font-size: ${({ theme }) => utils.rem(theme.Typography.Size.SmallHeavy.FontSize)};
  font-weight: ${({ theme }) => theme.Typography.Size.SmallHeavy.FontWeight};
  line-height: ${({ theme }) => utils.rem(theme.Typography.Size.SmallHeavy.LineHeight)};
`;

const EditedOn = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.Color.Neutrals.Gray};
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.Typography.Size.Small.FontFamily};
  font-size: ${({ theme }) => utils.rem(theme.Typography.Size.Small.FontSize)};
  font-weight: ${({ theme }) => theme.Typography.Size.Small.FontWeight};
  line-height: ${({ theme }) => utils.rem(theme.Typography.Size.Small.LineHeight)};
`;

const LikeCount = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.Color.Neutrals.Gray};
`;

const TimesAdded = styled.div`
  display: inline;
  margin-left: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XXSmall)}`};
  font-family: ${({ theme }) => theme.Typography.Size.Small.FontFamily};
  font-size: ${({ theme }) => utils.rem(theme.Typography.Size.Small.FontSize)};
  font-weight: ${({ theme }) => theme.Typography.Size.Small.FontWeight};
  line-height: ${({ theme }) => utils.rem(theme.Typography.Size.Small.LineHeight)};
`;

export const CardFooterStyles = {
  CardFootContainer,
  LeftColumn,
  CenterColumn,
  RightColumn,
  TemplateName,
  EditedOn,
  LikeCount,
  TimesAdded,
};
